module.exports = __webpack_public_path__ + "static/media/CalypsoAlt.2a00e708.mp3";